import $api from "@/frontend/shared/api/axios";

export async function patchUpdateRevisionLogo({ logo }: { logo: string }) {
  await $api.patch(`/founder-revisions/logo`, { base64Image: logo });
}
